var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { AzureCommunicationTokenCredential, } from "@azure/communication-common";
import { CallComposite, useAzureCommunicationCallAdapter, } from "@azure/communication-react";
import { initializeIcons } from "@fluentui/react";
import React, { useEffect, useMemo, useRef } from "react";
// import { validate as validateUUID } from "uuid";
initializeIcons();
const isTeamsMeetingLink = (link) => link.startsWith("https://teams.microsoft.com/l/meetup-join");
// const isGroupID = (id: string): boolean => validateUUID(id);
const createCallAdapterLocator = (locator) => {
    //   if (isTeamsMeetingLink(locator)) {
    return { meetingLink: locator };
    //   }
    //   } else if (isGroupID(locator)) {
    //     return { groupId: locator };
    //   } else if (/^\d+$/.test(locator)) {
    //     return { roomId: locator };
    //   }
    return undefined;
};
export const TeamsMeetingCandidate = (props) => {
    const { onMeetingEnd } = props;
    const credential = useMemo(() => {
        try {
            return new AzureCommunicationTokenCredential(props.token);
        }
        catch (_a) {
            console.error("Failed to construct token credential");
            return undefined;
        }
    }, [props.token]);
    const locator = useMemo(() => createCallAdapterLocator(props.locator), [props.locator]);
    const adapter = useAzureCommunicationCallAdapter({
        userId: props.userId,
        displayName: props.displayName,
        credential,
        locator,
    }, undefined, leaveCall);
    const hasLoggedEndRef = useRef(false);
    useEffect(() => {
        if (!adapter)
            return;
        const endedPages = [
            "leftCall",
            "leaving",
            "removedFromCall",
        ];
        const handleStateChange = (state) => {
            if (!hasLoggedEndRef.current && endedPages.includes(state.page)) {
                hasLoggedEndRef.current = true;
                console.log("[TeamsMeetingCandidate] Meeting ended");
                onMeetingEnd === null || onMeetingEnd === void 0 ? void 0 : onMeetingEnd();
            }
            else if (state.page === "call") {
                hasLoggedEndRef.current = false;
            }
        };
        adapter.onStateChange(handleStateChange);
        return () => {
            adapter.offStateChange(handleStateChange);
        };
    }, [adapter, onMeetingEnd]);
    if (!locator) {
        return _jsxs(_Fragment, { children: ["Provided call locator '", props.locator, "' is not recognized."] });
    }
    if (adapter) {
        return (_jsx("div", Object.assign({ style: { height: "calc(100vh - 64px)", width: "100vw" } }, { children: _jsx(CallComposite, { adapter: adapter, formFactor: props.formFactor, 
                //   fluentTheme={props.fluentTheme}
                rtl: props.rtl, callInvitationUrl: props === null || props === void 0 ? void 0 : props.callInvitationURL, locale: props === null || props === void 0 ? void 0 : props.locale, options: props === null || props === void 0 ? void 0 : props.options }) })));
    }
    if (credential === undefined) {
        return _jsx(_Fragment, { children: "Failed to construct credential. Provided token is malformed." });
    }
    return _jsx(_Fragment, { children: "Initializing..." });
};
const leaveCall = (adapter) => __awaiter(void 0, void 0, void 0, function* () {
    yield adapter.leaveCall().catch((e) => {
        console.error("Failed to leave call", e);
    });
});
